import PropTypes from "prop-types";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

export const ProgressBar = ({
  label = "",
  percentageLabel = "",
  progress = 0,
  hideLabel = false,
  hidePercentage = false,
  variant = "default",
  size = "sm",
}) => {
  if (progress > 100) {
    progress = 100;
  }

  if (progress < 0) {
    progress = 0;
  }

  const progressText = `${progress}% `;

  return (
    <div
      className={classNames({
        "flex items-center gap-2": variant === "inline",
      })}
    >
      <div
        className={classNames("rounded-full bg-gray-200 dark:bg-gray-600", {
          "h-1": size === "sm",
          "h-2": size === "md",
          "w-full": variant !== "inline",
          "w-20": variant === "inline",
        })}
      >
        <div
          className={classNames("rounded-full bg-gray-600 dark:bg-gray-200", {
            "h-1": size === "sm",
            "h-2": size === "md",
          })}
          style={{ width: `${progress}%` }}
        />
      </div>
      {!hideLabel && (
        <div className="text-dark flex justify-between pt-1">
          {label && <Typography.LabelSm>{label}</Typography.LabelSm>}
          {!hidePercentage && (
            <Typography.LabelSm>
              {progressText}
              {percentageLabel && (
                <Typography.LabelSm>{percentageLabel}</Typography.LabelSm>
              )}
            </Typography.LabelSm>
          )}
        </div>
      )}
    </div>
  );
};

ProgressBar.propTypes = {
  label: PropTypes.string,
  progress: PropTypes.number,
  hideLabel: PropTypes.bool,
  hidePercentage: PropTypes.bool,
  size: PropTypes.oneOf(["sm", "md"]),
  variant: PropTypes.oneOf(["default", "inline"]),
};
